/* Cairo 3D · catálogo (filtro + agregar al carrito) y encargo a WhatsApp. Se carga una vez aunque lo pidan varias secciones. */
(() => {
if (window.__cxTienda) return; window.__cxTienda = true;
const esc = s => (s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

/* ---------- Catálogo ---------- */
document.querySelectorAll('[data-cx-catalogo]').forEach(sec => {
  const chips = sec.querySelectorAll('.cx-chip'), cards = sec.querySelectorAll('.cx-card'), conteo = sec.querySelector('[data-conteo]');
  const toast = sec.querySelector('[data-toast]'), sinCajon = sec.hasAttribute('data-cx-sin-cajon'); let tt;
  const avisar = txt => { if (!toast) return; toast.textContent = txt; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('is-on'), 2600); };
  chips.forEach(ch => ch.addEventListener('click', () => {
    chips.forEach(c => c.setAttribute('aria-pressed', c === ch));
    let n = 0; cards.forEach(c => { const ok = !ch.dataset.tipo || c.dataset.tipo === ch.dataset.tipo; c.hidden = !ok; if (ok) n++; });
    if (conteo) conteo.textContent = n + (n === 1 ? ' pieza' : ' piezas');
  }));
  sec.addEventListener('click', async e => {
    const b = e.target.closest('[data-agregar]'); if (!b) return;
    b.disabled = true; const txt = b.textContent; b.textContent = 'Agregando…';
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.agregar, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) });
      const d = await r.json(); if (!r.ok) throw new Error(d.description || 'No se pudo agregar');
      const burbuja = document.getElementById('cart-icon-bubble');
      const cajon = document.querySelector('cart-drawer');
      if (sinCajon && cajon && cajon.getSectionsToRender && d.sections && d.sections['cart-drawer']) {
        /* Actualiza cajón y burbuja sin abrirlo, para seguir agregando desde la página. */
        cajon.classList.remove('is-empty');
        cajon.getSectionsToRender().forEach(s => { const el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id); if (el) el.innerHTML = cajon.getSectionInnerHTML(d.sections[s.id], s.selector); });
        const capa = cajon.querySelector('#CartDrawer-Overlay'); if (capa) capa.addEventListener('click', cajon.close.bind(cajon));
      }
      else if (cajon && cajon.renderContents && d.sections && d.sections['cart-drawer']) { cajon.classList.remove('is-empty'); cajon.renderContents(d); }
      else if (burbuja && d.sections && d.sections['cart-icon-bubble']) { const t = new DOMParser().parseFromString(d.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (t) burbuja.innerHTML = t.innerHTML; }
      b.textContent = 'Agregado ✓'; if (!sinCajon) avisar('Agregado al carrito: ' + b.dataset.nombre);
    } catch (err) { b.textContent = txt; avisar(err.message); }
    setTimeout(() => { b.textContent = txt; b.disabled = false; }, 1800);
  });
});

/* ---------- Encargo → WhatsApp ---------- */
const sec = document.querySelector('[data-cx-encargo]');
if (!sec) return;
const $ = s => sec.querySelector(s);
const WA = sec.dataset.wa, IA = sec.dataset.ia, TS = sec.dataset.tsKey;
const hoy = new Date();
const folio = 'C3-' + String(hoy.getMonth() + 1).padStart(2, '0') + String(hoy.getDate()).padStart(2, '0') + '-' + Math.random().toString(36).slice(2, 5).toUpperCase();
const E = { fotos: [], links: [], ia: null, estilo: 'Divertido y colorido' };
const form = $('[data-form]');
const campo = n => form.elements[n];

sec.querySelectorAll('.cx-ref').forEach(b => b.addEventListener('click', () => {
  const p = $('[data-p="' + b.dataset.panel + '"]'); const abrir = p.hidden;
  p.hidden = !abrir; b.setAttribute('aria-expanded', abrir);
  if (abrir && b.dataset.panel === 'link') $('[data-link]').focus();
}));
// fotos (solo vista previa; se adjuntan en el chat)
const fIn = $('[data-fotos]'), drop = $('[data-drop]');
function agregarFotos(files) { [...files].filter(f => f.type.startsWith('image/')).slice(0, 3 - E.fotos.length).forEach(f => E.fotos.push(URL.createObjectURL(f))); pintarFotos(); armar(); }
function pintarFotos() {
  $('[data-thumbs]').innerHTML = E.fotos.map((u, i) => `<figure><img src="${u}" alt="Foto de referencia ${i + 1}"><button type="button" data-del="${i}" aria-label="Quitar foto ${i + 1}">×</button></figure>`).join('');
  $('[data-cnt-foto]').textContent = E.fotos.length ? E.fotos.length + (E.fotos.length > 1 ? ' fotos' : ' foto') : '';
}
fIn.addEventListener('change', () => { agregarFotos(fIn.files); fIn.value = ''; });
['dragenter', 'dragover'].forEach(t => drop.addEventListener(t, e => { e.preventDefault(); drop.classList.add('is-over'); }));
['dragleave', 'drop'].forEach(t => drop.addEventListener(t, e => { e.preventDefault(); drop.classList.remove('is-over'); }));
drop.addEventListener('drop', e => agregarFotos(e.dataTransfer.files));
$('[data-thumbs]').addEventListener('click', e => { const b = e.target.closest('[data-del]'); if (!b) return; URL.revokeObjectURL(E.fotos.splice(+b.dataset.del, 1)[0]); pintarFotos(); armar(); });
// enlaces
const fuente = u => { try { const h = new URL(u).hostname.replace(/^www\./, ''); return { 'pin.it': 'Pinterest', 'pinterest.com': 'Pinterest', 'mx.pinterest.com': 'Pinterest', 'instagram.com': 'Instagram', 'tiktok.com': 'TikTok', 'makerworld.com': 'MakerWorld', 'thingiverse.com': 'Thingiverse', 'printables.com': 'Printables', 'amazon.com.mx': 'Amazon', 'mercadolibre.com.mx': 'Mercado Libre' }[h] || h; } catch (e) { return ''; } };
function addLink() {
  const inp = $('[data-link]'), v = inp.value.trim(); let ok = false; try { ok = /^https?:$/.test(new URL(v).protocol); } catch (e) {}
  $('[data-err-link]').hidden = ok || !v; if (!ok) return;
  if (!E.links.includes(v) && E.links.length < 5) E.links.push(v);
  inp.value = ''; pintarLinks(); armar();
}
function pintarLinks() {
  $('[data-links]').innerHTML = E.links.map((l, i) => `<li><span>${esc(l)}</span><em>${esc(fuente(l))}</em><button type="button" data-dl="${i}" aria-label="Quitar enlace">×</button></li>`).join('');
  $('[data-cnt-link]').textContent = E.links.length ? E.links.length + (E.links.length > 1 ? ' enlaces' : ' enlace') : '';
}
$('[data-add-link]').addEventListener('click', addLink);
$('[data-link]').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); addLink(); } });
$('[data-link]').addEventListener('paste', () => setTimeout(addLink, 0));
$('[data-links]').addEventListener('click', e => { const b = e.target.closest('[data-dl]'); if (!b) return; E.links.splice(+b.dataset.dl, 1); pintarLinks(); armar(); });
// boceto con IA (Worker de Cairo Studio)
// Turnstile (anti-robots de Cloudflare): se carga al empezar a escribir y da un token de un solo uso por boceto.
let tsWidget = null, tsCarga = null, tsPendiente = null;
function cargarTurnstile() {
  if (!TS) return Promise.resolve(null);
  tsCarga = tsCarga || new Promise((ok, mal) => {
    window.cxTurnstileListo = () => ok(window.turnstile);
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=cxTurnstileListo';
    s.async = true; s.onerror = () => { tsCarga = null; mal(new Error('No pudimos cargar la verificación. Revisa tu conexión e intenta otra vez.')); };
    document.head.appendChild(s);
  });
  return tsCarga;
}
async function tokenTurnstile() {
  const ts = await cargarTurnstile();
  if (!ts) return '';
  return new Promise((ok, mal) => {
    tsPendiente = { ok, mal };
    if (tsWidget === null) tsWidget = ts.render($('[data-ts]'), {
      sitekey: TS, execution: 'execute', appearance: 'interaction-only', language: 'es',
      callback: t => tsPendiente && tsPendiente.ok(t),
      'error-callback': () => tsPendiente && tsPendiente.mal(new Error('No pudimos confirmar que eres una persona. Intenta otra vez.'))
    });
    else ts.reset(tsWidget);
    ts.execute(tsWidget);
  });
}
campo('idea').addEventListener('focus', () => { cargarTurnstile().catch(() => {}); }, { once: true });
$('[data-estilos]').addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; E.estilo = b.textContent; $('[data-estilos]').querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', x === b)); });
$('[data-ia-btn]').addEventListener('click', async () => {
  if (!validarIdea()) return;
  const b = $('[data-ia-btn]'), est = $('[data-ia-estado]');
  b.disabled = true; b.textContent = 'Imaginando tu pieza…'; est.textContent = 'Creando tu boceto. Puede tardar hasta un minuto.';
  const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 90000);
  try {
    const datos = { piece: campo('piece').value, style: E.estilo, idea: campo('idea').value.trim(), colors: campo('colors').value.trim(), size: campo('size').value.trim(), quantity: campo('quantity').value, lettering: '' };
    const token = await tokenTurnstile();
    const r = await fetch(IA, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...datos, token }), signal: ctl.signal, credentials: 'omit' });
    const d = await r.json();
    if (!r.ok || typeof d.image !== 'string' || !d.image.startsWith('data:image/')) throw new Error(d.error || 'No pudimos generar la imagen. Intenta más tarde.');
    E.ia = d.image; $('[data-boceto-img]').src = d.image; $('[data-boceto-img]').alt = 'Boceto con IA: ' + datos.idea; $('[data-boceto-dl]').href = d.image;
    $('[data-boceto]').hidden = false; est.textContent = '¡Listo! Si te gusta, mándalo por WhatsApp; si no, crea otra versión.'; armar();
    $('[data-boceto]').scrollIntoView({ behavior: 'smooth', block: 'center' });
  } catch (err) { est.textContent = err.name === 'AbortError' ? 'Tardó demasiado. Puedes cotizar tu idea sin boceto.' : (err.message || 'No hay conexión con la IA. Puedes cotizar sin boceto.'); }
  finally { clearTimeout(timer); b.disabled = false; b.textContent = 'Ver cómo quedaría ✦'; b.hidden = !!E.ia; }
});
// mensaje
function validarIdea() { const ok = campo('idea').value.trim().length >= 8; $('[data-err-idea]').hidden = ok; if (!ok) campo('idea').focus(); return ok; }
const fechaTxt = v => v ? new Date(v + 'T12:00').toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
function mensaje() {
  const L = ['Hola Cairo 3D, quiero cotizar una pieza por encargo.', '', `*Folio:* ${folio}`, `*Idea:* ${campo('idea').value.trim() || '—'}`, `*Tipo:* ${campo('piece').value}`,
    `*Tamaño:* ${campo('size').value.trim() || 'Por definir'}`, `*Colores:* ${campo('colors').value.trim() || 'Por definir'}`, `*Cantidad:* ${campo('quantity').value || 1}`];
  if (campo('fecha').value) L.push(`*Para cuándo:* ${fechaTxt(campo('fecha').value)}`);
  if (campo('cp').value.trim()) L.push(`*CP:* ${campo('cp').value.trim()}`);
  const refs = [];
  if (E.fotos.length) refs.push(`• ${E.fotos.length} ${E.fotos.length > 1 ? 'fotos' : 'foto'} de referencia (te las mando en este chat)`);
  E.links.forEach(l => refs.push(`• ${fuente(l)}: ${l}`));
  if (E.ia) refs.push(`• Boceto con IA, estilo ${E.estilo} (te lo mando en este chat)`);
  if (refs.length) L.push('', '*Referencias:*', ...refs);
  return L.join('\n');
}
function armar() {
  const cp = campo('cp'); cp.value = cp.value.replace(/\D/g, '').slice(0, 5); $('[data-err-cp]').hidden = !cp.value || cp.value.length === 5;
  const msg = mensaje();
  const imgs = E.fotos.map(u => `<img src="${u}" alt="">`).join('') + (E.ia ? `<img src="${E.ia}" alt="">` : '');
  const cuerpo = esc(msg).replace(/\*(.+?)\*/g, '<b>$1</b>').replace(/(https?:\/\/[^\s<]+)/g, '<span class="cx-lnk">$1</span>');
  $('[data-burbuja]').innerHTML = (imgs ? `<div class="cx-imgs">${imgs}</div>` : '') + cuerpo + `<span class="cx-hora">${new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}</span>`;
  const btn = $('[data-wa-btn]'); btn.href = `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`; btn.setAttribute('aria-disabled', campo('idea').value.trim().length < 8);
  return msg;
}
form.addEventListener('input', armar);
// Enviar a WhatsApp: en celular comparte el boceto como imagen junto con el mensaje; en compu descarga el boceto y abre el chat
async function enviarWA(e) {
  if (!validarIdea()) { e && e.preventDefault(); return; }
  const msg = armar();
  if (!E.ia) return; // sin boceto: el enlace normal de WhatsApp hace el trabajo
  e && e.preventDefault();
  try { await navigator.clipboard.writeText(msg); } catch (x) {}
  try {
    const blob = await (await fetch(E.ia)).blob();
    const file = new File([blob], 'boceto-' + folio + '.jpg', { type: blob.type || 'image/jpeg' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text: msg }); return; }
  } catch (x) { if (x && x.name === 'AbortError') return; }
  const a = $('[data-boceto-dl]'); a.download = 'boceto-' + folio + '.jpg'; a.click();
  $('[data-ia-estado]').textContent = 'Se descargó tu boceto: adjúntalo en el chat de WhatsApp que se abrió.';
  window.open(`https://wa.me/${WA}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
}
$('[data-wa-btn]').addEventListener('click', enviarWA);
$('[data-ia-enviar]').addEventListener('click', enviarWA);
$('[data-ia-otra]').addEventListener('click', () => { const b = $('[data-ia-btn]'); b.hidden = false; b.click(); });
$('[data-copiar]').addEventListener('click', async () => {
  const msg = armar(), b = $('[data-copiar]');
  try { await navigator.clipboard.writeText(msg); b.textContent = 'Mensaje copiado'; } catch (e) { b.textContent = 'No se pudo copiar'; }
  setTimeout(() => b.textContent = 'Copiar mensaje', 2200);
});
armar();
})();
